import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';

import {
  QuestionnaireElement, QuestionnaireElementHeadline, QuestionnaireElementMultipleChoice,
  QuestionnaireElementSlider
} from '../../models/questionnaire-element';


import { NaviService } from '../../services/navi.service';
import { PatientQuestionnaireService } from '../../services/patient-questionnaire.service';
import { Questionnaire } from '../../models/questionnaire';
import { Alarm } from '../../models/alarm';
import { BasicError, Error403, Error409 } from '../../models/error/error';

@Component({
  selector: 'app-questionnaire-details',
  templateUrl: './questionnaire-details.component.html',
  styleUrls: ['./questionnaire-details.component.css']
})
export class QuestionnaireDetailsComponent implements OnInit {
  public questId: String;
  public question: Questionnaire;
  public questionElements;

  // Vars for selecting Choice or Answers for the Questionnaires
  public answerList = [];
  public markAsIncomplete = [];
  public isSet = true;

  public isSend = false;
  public waitForFeedback = false;
  public feedbacks: Array<Alarm> = [];

  constructor(private patientQuestionnaire: PatientQuestionnaireService, private route: ActivatedRoute,
    private naviService: NaviService) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.questId = params.get('id');
      this.question = new Questionnaire(this.questId);

      return this.patientQuestionnaire.getMyQuestionnaireDetail(this.question)
    }).subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      } else if (data instanceof Questionnaire) {
        this.question = data;
        this.getQuestionElements();
      }
    });

    this.isSend = false;
  }

  // Gets the Elements from a questionnaire
  public getQuestionElements() {
    this.patientQuestionnaire.getMyQuestionnaireStructure(this.question).subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      } else {
        this.questionElements = data;
        for (const elem of this.questionElements) {
          if (elem instanceof QuestionnaireElementMultipleChoice) {
            const answerMultipleC = [];
            for (const el of elem.getAnswers('patient')) {
              answerMultipleC.push(null);
            }
            this.answerList.push(answerMultipleC);
          } else {
            this.answerList.push(null);
          }

          this.markAsIncomplete.push(false);

        }
      }
    });
  }

  public sendAnswers() {
    this.isSet = true;
    const answers = [];

    for (let i = 0; i < this.questionElements.length; i++) {
      const elem = this.questionElements[i];
      const answ = {};

      if (elem instanceof QuestionnaireElementMultipleChoice) {
        const values = [];

        for (let j = 0; j < this.answerList[i].length; j++) {
          const x = this.answerList[i][j];

          if (x !== null && x === true) {
            values.push(elem.getValues()[j]);
          }
        }

        if (elem.isRequired() && values.length === 0) {
          this.isSet = false;
          this.markAsIncomplete[i] = true;
        } else if (values.length > 0) {
          answ['label'] = elem.getLabel();
          answ['value'] = values;
          answers.push(answ);
        }
      } else if (!(elem instanceof QuestionnaireElementHeadline)) {
        if (elem.isRequired() && this.answerList[i] === null) {
          this.isSet = false;
          this.markAsIncomplete[i] = true;
        } else if (this.answerList[i] !== null) {
          answ['label'] = elem.getLabel();
          answ['value'] = this.answerList[i];
          answers.push(answ);
        }
      }

    }

    if (this.isSet) {
      if (this.question.isMultiple()) {
        this.waitForFeedback = true;
      }

      this.patientQuestionnaire.submitAnswersOfQuestionnaire(this.questId, answers).subscribe(json => {
        if (json instanceof BasicError) {
          console.log('Submitting answers failed!!!');
          console.log(json);
        } else {
          const answersheetId = json;

          if (this.waitForFeedback) {
            // Evaluate answersheet
            this.patientQuestionnaire.evaluateAnswersheet(answersheetId).subscribe(dd => {
              if (dd instanceof BasicError) {
                console.log('Error in evaluation of answersheet');
                console.log(dd)
              } else {
                this.feedbacks = dd;
              }

              this.waitForFeedback = false; // Loading feedbacks was done
            });
          }
        }
      });
      this.isSend = true;
    } else {
      console.log('Es müssen alle erforderlichen Felder ausgefüllt werden!');
    }
  }

  public navigateToMyQuestionnaires() {
    this.naviService.navigateToUrl('/myquestionnaires', 'myquestionnaires');
  }
}





// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/questionnaire-details/questionnaire-details.component.ts